/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file Layout Component
 * @author Dustin Gage
 */

import React, { memo, Suspense, ReactElement } from "react";

import { Header } from "./Header";
import { Footer } from "./Footer";
import { Switch, Route, Redirect, HashRouter } from "react-router-dom";
import { Loader } from "../Loader";
import { routes } from "../../routes";
import { Landing } from "../pages/Landing";
import { SiteImage } from "../SiteImage";
import { useSettings } from "../../api/use-settings";
import { Analytics } from "../Analytics";

export const Layout = memo(function Layout(): ReactElement {
	const { bannerLogo } = useSettings();
	const hasBannerLogo = !!bannerLogo && !!bannerLogo.url && !!bannerLogo.image;

	return (
		<>
			<Header />
			<div className="container container-force-lg">
				<div id="LogosContainer">
					{hasBannerLogo && (
						<a className="logo-link" href={bannerLogo.url}>
							<SiteImage localPath={"custom/images/" + bannerLogo.image} />
						</a>
					)}
				</div>

				<HashRouter>
					<Suspense fallback={<Loader />}>
						<Switch>
							{routes.map(route => (
								<Route key={route.path} path={`/${route.path}`} component={route.component} />
							))}
							<Route exact key={"default"} path={"/"} component={Landing} />
							<Redirect to={"/"} />
						</Switch>
					</Suspense>

					<Route path="/" component={Analytics} />
				</HashRouter>
			</div>
			<Footer />
		</>
	);
});
